import { ActivatedRoute } from '@angular/router';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'app-error',
  standalone: true,
  templateUrl: './error.component.html',
})
export class ErrorComponent {
  private route = inject(ActivatedRoute);

  message = '';

  constructor() {
    this.message = this.route.snapshot.queryParams['reason'] || 'Sorry there was a problem.';
  }
}
